import React from "react";
import { useSelector } from "react-redux";
import C from "Constants";
import { TranslationText } from "components/TextTranslationContainer";
import { PriceRender } from "components/DisplayPrice";

// Helper line for a checkout button that is blocked by the store's minimum
// order value. The button only says "Add <amount> more", and the minimum is
// shown nowhere on the basket or checkout screen, so the customer sees a
// demand that relates to nothing on screen. This restates both figures.
//
// cartTotal is the items subtotal before any discount, which is what the
// block itself compares against — do not swap it for a post-discount total,
// or redeeming loyalty credits would push a customer below the minimum.
const MinOrderNotice = ({ minOrder, cartTotal }) => {
  const { orderType } = useSelector((state) => state?.AppReducer);

  const remaining = Number(minOrder || 0) - Number(cartTotal || 0);

  // only while the button is actually blocked, and delivery only
  if (remaining <= 0) return null;
  if (orderType?.EN?.name !== C.SERVICE_TYPE.DELIVERY) return null;

  return (
    <div className="w-full flex gap-1 flex-wrap items-center justify-center text-14x mb-3">
      <TranslationText text="Add" />
      <PriceRender price={+remaining.toFixed(2)} className="text-14x leading-none" />
      <TranslationText text="more" />
      <TranslationText text="to reach the minimum order for delivery of" />
      <PriceRender price={Number(minOrder || 0)} className="text-14x leading-none" />
    </div>
  );
};

export default MinOrderNotice;
